module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House10.6bb961cf.jpg";